import { Image, makeStyles, tokens } from "@fluentui/react-components";
import * as React from "react";

export const SignedOut: React.FC = () => {
  const styles = useStyles();

  return (
    <div className={styles.container}>
      <Image src="/assets/aiir-logo.svg" alt="Aiir" width={"128px"} />
      <h2>Welcome</h2>
      <p>You must be signed into Microsoft Office to use the Aiir Add-In.</p>
    </div>
  );
};

const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100vh",
    gap: "24px",
    backgroundColor: tokens.colorNeutralBackground2,
  },
});
